require("./Menu.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = { active: 'dashboard' };
        GState.bind(this, [
            'tenant',
            'skeleton',
            'screen',
            'showMenu'
        ]);
    },
    onMount: function () {
        const path = location.pathname;
        for (let page in this.state.skeleton.pages)
            if (this.state.skeleton.pages[page].path == path) {
                this.state.active = page;
                break;
            }
    },
    makeActive: function (page) {
        this.state.active = page;
        navigate(this.state.skeleton.pages[page].path);
    },
    autoHideMenu: function (e) {
        if (!this.state.showMenu || ![
                'xs',
                'sm',
                'md'
            ].includes(this.state.screen.media) || $(e.target).hasClass('btn-show-menu'))
            return;
        GState.menu.show(false);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Menu.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    marko_attrs0 = {
        "class": "list-unstyled position-relative height-100vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("2a82aa"),
    marko_node0 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "nav-item"
      },
    marko_attrs2 = {
        "class": "nav-item position-absolute bottom-0 width-100",
        style: "cursor:pointer"
      },
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.be("nav", {
      "class": marko_classValue("theme-bg " + (!state.showMenu ? "hide" : [
          "xs",
          "sm",
          "md"
        ].includes(state.screen.media) ? "show" : "")),
      id: "Menu"
    }, "0", component, null, 1);

  out.be("ul", marko_attrs0, "1", component);

  out.n(marko_node0, component);

  out.be("li", marko_attrs1, "3", component);

  Image_tag({
      alt: "Tenant Logo",
      src: state.tenant.logo,
      style: "width:40px;height:40px",
      class: "rounded"
    }, out, __component, "4");

  out.ee();

  marko_forOf(state.skeleton.menu, function(page, key) {
    var $keyValue$0 = "@" + key,
        $keyScope$0 = "[" + ($keyValue$0 + "]");

    out.be("li", {
        "class": marko_classValue(marko_classValue([
          "nav-item rounded",
          (((state.skeleton.pages[page].hidden || []).includes(state.screen.media) ? " d-none" : "") + " ") + (state.active == page ? " active" : "")
        ])),
        style: "cursor:pointer"
      }, $keyValue$0, component, null, 1, {
        onclick: __component.d("click", "makeActive", false, [
            page
          ])
      });

    Bx_tag({
        type: state.skeleton.pages[page].icon,
        class: "bx-md"
      }, out, __component, "5" + $keyScope$0);

    out.e("br", null, "6" + $keyScope$0, component, 0);

    out.be("div", null, "7" + $keyScope$0, component);

    Locale_tag({
        text: state.skeleton.pages[page].title
      }, out, __component, "8" + $keyScope$0);

    out.ee();

    out.e("span", {
        "class": marko_classValue(marko_classValue([
          "dot",
          "" + (state.active == page ? "theme-bg-primary" : "d-none")
        ]))
      }, "9" + $keyScope$0, component, 0, 1);

    out.ee();
  });

  out.be("li", marko_attrs2, "10", component, null, 0, {
      onclick: __component.d("click", () => navigate('/settings'), false)
    });

  Bx_tag({
      type: "cog",
      class: "bx-md"
    }, out, __component, "11");

  out.n(marko_node1, component);

  out.be("div", null, "13", component);

  Locale_tag({
      text: "Settings"
    }, out, __component, "14");

  out.ee();

  out.e("span", {
      "class": marko_classValue(marko_classValue([
        "dot",
        "" + (state.active == "settings" ? "theme-bg-primary" : "d-none")
      ]))
    }, "15", component, 0, 1);

  out.ee();

  out.ee();

  out.ee();

  subscribe_tag({
      to: document,
      __events: [
        "on",
        "click"
      ]
    }, out, __component, "16", [
    [
      "click",
      "autoHideMenu",
      false
    ]
  ]);
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
